/**
 * Dialog utility to enable more accessible and feature-rich dialogs.
 * This class is a work in progress.
 */
import reset from "./resetEvents.js";
export default class Dialog {
    constructor(element, options = {}) {
        this.el = element;
        this.options = {
            backdropClose: true,
            ...options,
        };
        this.name = this.el.getAttribute("data-dialog");

        this.dialogOpenElements = document.querySelectorAll(
            "[data-dialog-open='" + this.name + "']",
        );
        this.dialogCloseElements = document.querySelectorAll(
            "[data-dialog-close='" + this.name + "']",
        );
        this.dialogCloseElements = Array.from(this.dialogCloseElements).concat(
            Array.from(this.el.querySelectorAll("[data-dialog-close]")),
        );

        this.init();
    }

    init() {
        this.dialogOpenElements.forEach((element) => {
            element.addEventListener("click", (e) => {
                this.open(e);
                // If the site header search button is clicked open the menu with the search panel open
                if (e.currentTarget.hasAttribute("data-search")) {
                    this.openSiteSearch();
                }
            });
        });

        this.dialogCloseElements.forEach((element) => {
            element.addEventListener("click", (e) => {
                this.close(e);
            });
        });

        // Optionally close dialog when clicking on backdrop
        this.el.addEventListener("click", (e) => {
            if (this.options.backdropClose && e.target === this.el) {
                this.close(e);
            }
        });

        // Handle the 'close' event
        this.el.addEventListener("close", () => {
            this.onClose();
        });

        this.setScrollbarWidth();
        this.setHeaderHeight();
    }

    open(e) {
        this.fixBody();

        this.el.showModal();

        document.body.classList.add("dialog-is-open");
        document.body.classList.add(`${this.name}-dialog-is-open`);

        this.el.setAttribute("aria-hidden", "false");

        // If a content is specified, inject the content into the dialog's slot
        if (this.contentSlot && this.content) {
            this.contentSlot.innerHTML = this.content.innerHTML;
        }

        // If a dialog type has been set, add it as a data attribute
        if (this.type) {
            this.el.setAttribute("data-type", type);
        }

        if (this.name == "site-header-dialog") {
            window.scrollTo(0, 0);
        }

        setTimeout(() => {
            reset.refreshCarousels(this.el);
        }, 1);
    }

    close(e) {
        if (this.name == "site-header-dialog") {
            this.el.classList.add("closing");
            setTimeout(() => {
                this.el.close();
                this.el.classList.remove("closing");
                this.closeSiteSearch();
            }, 500);
        } else {
            this.el.close();
        }
    }

    stopVideo() {
        const iframe = this.el ? this.el.querySelector("iframe") : null;
        if (iframe) iframe.src = iframe.src;
    }

    onClose() {
        this.unfixBody();
        this.stopVideo();

        document.body.classList.remove("dialog-is-open");
        document.body.classList.remove(`${this.name}-dialog-is-open`);

        this.el.setAttribute("aria-hidden", "true");
        this.el.setAttribute("data-type", "");
    }

    fixBody() {
        document.documentElement.classList.add("no-scroll");
    }

    unfixBody() {
        document.documentElement.classList.remove("no-scroll");
    }

    setScrollbarWidth() {
        // Use this to stop elements jumping when dialog is opened
        document.documentElement.style.setProperty(
            "--scrollbar-width",
            window.innerWidth - document.documentElement.clientWidth + "px",
        );
    }

    setHeaderHeight() {
        // Use this to stop elements jumping when dialog is opened
        document.documentElement.style.setProperty(
            "--header-height",
            document.getElementById("site-header").offsetHeight + "px",
        );
    }

    openSiteSearch() {
        this.setHeaderHeight();
        const search_buttons = this.el.querySelectorAll(
            '[aria-controls="searchPanel"]',
        );
        const search_panel = this.el.querySelector("#searchPanel");

        search_buttons.forEach((e) => {
            e.setAttribute("aria-expanded", "true");
        });
        search_panel.setAttribute("aria-hidden", "false");
        search_panel.removeAttribute("hidden");
        document.getElementById("searchFormInput").focus();
    }

    closeSiteSearch() {
        const search_buttons = this.el.querySelectorAll(
            '[aria-controls="searchPanel"]',
        );
        const search_panel = this.el.querySelector("#searchPanel");

        search_buttons.forEach((e) => {
            e.setAttribute("aria-expanded", "false");
        });
        search_panel.setAttribute("aria-hidden", "true");
        search_panel.addAttribute("hidden");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const dialogElements = document.querySelectorAll("[data-dialog]");

    dialogElements.forEach((element) => {
        new Dialog(element);
    });
});
